export default __webpack_public_path__ + "static/media/misc-pantry1-2048w.21f59fd4.avif";